import styled from 'styled-components';

export const SearchPageWrapper = styled.div`
  display: flex;
  width: 100%;
  min-height: 600px;
  height: 100%;
`;

export const SearchPanelWrapper = styled.div`
  height: 100%;
  border: 1px solid grey;
  flex: 1;
  display: flex;
  flex-direction: column;
`;
